import React from 'react';
import Form from './Form';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Create = () => {

    const {addData} = useEntityCrud('User/SetUser');
    const navigate = useNavigate();

    const initialValues = {
        name: '',
        lastName: '',
        nationalCode: '',
        phone: '',
        businessId: [],
        role: ''
    };
    
    const validationSchema = Yup.object({
        name: Yup.string()
        .required(),
        lastName: Yup.string()
        .required(),
        nationalCode: Yup.string()
        .test('nationalCode','کد ملی وارد شده معتبر نمی باشد',code => {
            if(!code || code.length != 10)
                return false;
            let L = code.length;
            if(L < 8 || parseInt(code,10) == 0) return false;
            code = ('0000' + code).substr(L + 4 - 10);
            if(parseInt(code.substr(3,6),10)==0) return false;
            let c = parseInt(code.substr(9,1),10);
            let s = 0;
            for(let i = 0;i < 9;i++)
                s += parseInt(code.substr(i,1),10) * (10 - i);
            s = s % 11;
            return (s < 2 && c == s) || (s >= 2 && c == (11 - s));
        })
        .required(),
        phone: Yup.string()
        .test('phone','شماره همراه وارد شده معتبر نمی باشد',value => {
            return value && /^\d+$/.test(value.toString().replace('-','')) && value.startsWith('09') && value.length == 12;
        }),
        password: Yup.string()
        .min(6,'طول رمز عبور وارد شده کوتاه است')
        .required(),
        roleId: Yup.number()
        .required(),
    });
    
    const onSubmit = (values) => {
        document.getElementById('btn-submit-form').classList.add('btn-loading');
        let businessId = [];
        if(values.businessId.length)
            values.businessId.map(item => businessId.push(item.value));
        const postedData = {
            firstName: values.name,
            lastName: values.lastName,
            nationalCode: values.nationalCode,
            mobile: values.phone.replace('-',''),
            token: '',
            username: values.nationalCode,
            password: values.password,
            roleId: values.roleId,
            businessId: businessId
       };
       if(values.guildId){
            if(typeof values.guildId == 'number')
                postedData.guildId = [values.guildId]
            else{
                const guilds = []
                values.guildId.map(guild => guilds.push(guild.value))
                postedData.guildId = guilds
            }
       }
       addData(postedData).then(({data}) => {
            if(data.status){
                toast.success('کاربر جدید با موفقیت ایجاد شد');
                return navigate('/users');
            }
            else
                data.errors.map(error => toast.error(error.message));
        }).finally(() => document.getElementById('btn-submit-form').classList.remove('btn-loading'));
    }

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit,
        validationSchema: validationSchema
    });

    const handleBack = () => {
        navigate('/users',{replace: true});
    }

    return (
        <div className="card">
            <div className="card-header d-flex justify-content-between">
                <div className="card-title">ایجاد کاربر جدید</div>
                <a className="backIconLink" onClick={handleBack}><i className="fa fa-arrow-left" title="بازگشت"></i></a>
            </div>
            <div className="card-body">
                <Form formik={formik} />
            </div>
        </div>
    );
}

export default Create;